var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInformation(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.833496 8.00065C0.833496 4.05784 4.05735 0.833984 8.00016 0.833984C11.943 0.833984 15.1668 4.05784 15.1668 8.00065C15.1668 11.9435 11.943 15.1673 8.00016 15.1673C4.05735 15.1673 0.833496 11.9435 0.833496 8.00065ZM8.00016 1.83398C4.60964 1.83398 1.8335 4.61013 1.8335 8.00065C1.8335 11.3912 4.60964 14.1673 8.00016 14.1673C11.3907 14.1673 14.1668 11.3912 14.1668 8.00065C14.1668 4.61013 11.3907 1.83398 8.00016 1.83398Z",
    fill: "#C9B181"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.99808 4.50065C8.27422 4.50065 8.49808 4.72451 8.49808 5.00065V8.33398C8.49808 8.61013 8.27422 8.83398 7.99808 8.83398C7.72194 8.83398 7.49808 8.61013 7.49808 8.33398V5.00065C7.49808 4.72451 7.72194 4.50065 7.99808 4.50065Z",
    fill: "#C9B181"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.32751 11.0007C7.32751 10.6325 7.62599 10.334 7.99417 10.334H8.00016C8.36835 10.334 8.66683 10.6325 8.66683 11.0007C8.66683 11.3688 8.36835 11.6673 8.00016 11.6673H7.99417C7.62599 11.6673 7.32751 11.3688 7.32751 11.0007Z",
    fill: "#C9B181"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInformation);
export default __webpack_public_path__ + "static/media/information.f516ace4ee4ec175f15717c23e4ad0d3.svg";
export { ForwardRef as ReactComponent };